var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceidIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#5f00a0",
    transform: "translate(4.333 3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.515 17.645h15.926a7.979 7.979 0 0 0-15.926 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.478,
    cy: 4.906,
    r: 4.239
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M.433 0A.433.433 0 0 0 0 .433V5.2h.867V.867H5.2V0H.433zM25.567 0H20.8v.867h4.333V5.2H26V.433A.433.433 0 0 0 25.567 0zM.867 25.133V20.8H0v4.767c0 .239.194.433.433.433H5.2v-.867H.867zM25.133 20.8v4.333H20.8V26h4.767c.239 0 .433-.194.433-.433V20.8h-.867z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceidIconGreen);
export default __webpack_public_path__ + "static/media/faceid_icon_green.f03b37a09ccf79dc4ee1560ba5be009b.svg";
export { ForwardRef as ReactComponent };